import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Grid, Icon, Image } from 'semantic-ui-react';

import { RecipeFieldEnum as RecipeFields } from 'Common/FieldEnum';
import { FALLBACK_IMAGE } from 'Common/Constants';
import { prependBase64 } from 'Common/Helpers/format';

import { NutritionalHoverConnected } from '../NutritionalHover/NutritionalHover';

class RecipeItem extends Component {
  static propTypes = {
    item: PropTypes.object,
    iconName: PropTypes.string,
    iconClass: PropTypes.string,
    bordered: PropTypes.bool,
    loading: PropTypes.bool,
    onAddRecipe: PropTypes.func,
    index: PropTypes.number,
    disableHover: PropTypes.bool,
    enableDnD: PropTypes.bool,
    showIcon: PropTypes.bool,
    footerItems: PropTypes.arrayOf(
      PropTypes.shape({
        fieldName: PropTypes.string,
        render: PropTypes.func,
      })
    ),
  };

  static defaultProps = {
    bordered: false,
    loading: true,
    onAddRecipe: () => {},
    index: 0,
    disableHover: false,
    enableDnD: true,
    showIcon: true,
    footerItems: [
      {
        fieldName: RecipeFields.Id,
        render: ({ value, ...rest }) => <span {...rest}>{`R#: ${value}`}</span>,
      },
      {
        fieldName: RecipeFields.ProductCode,
        render: ({ value, ...rest }) => <span {...rest}>{value}</span>,
      },
      {
        fieldName: RecipeFields.ManufacturerName,
        render: ({ value, ...rest }) => <span {...rest}>{value}</span>,
      },
    ],
  };

  onAddRecipe = () => {
    const { onAddRecipe, index } = this.props;

    onAddRecipe(index);
  };

  renderDraggableTitle({ index, shortName }) {
    return (
      <Draggable index={index} draggableId={`recipe-item-${index}`}>
        {(provided, snapshot) => {
          const { isDragging } = snapshot;
          const recipeNameClass = classNames('rs-menu-item-name', {
            dragging: isDragging,
          });

          let style = {};

          if (isDragging) {
            style = provided.draggableProps.style;
          }

          const child = (
            <span
              ref={provided.innerRef}
              className={recipeNameClass}
              title={shortName}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={style}
            >
              {shortName}
            </span>
          );

          if (isDragging) {
            return ReactDOM.createPortal(child, document.body);
          }

          return child;
        }}
      </Draggable>
    );
  }

  renderTitle({ shortName }) {
    return (
      <span className="rs-menu-item-name" title={shortName}>
        {shortName}
      </span>
    );
  }

  render() {
    const {
      item,
      iconClass,
      iconName,
      bordered,
      loading,
      index,
      disableHover,
      enableDnD,
      showIcon,
      footerItems,
    } = this.props;

    const {
      Picture,
      Name: shortName,
      Description: longName,
      Id: recipeCode,
      ServingSize,
    } = item;

    const imageSrc = Picture ? prependBase64(Picture) : FALLBACK_IMAGE;
    const iconClassName = classNames(iconClass);

    const recipeItemClass = classNames('rs-menu-item', {
      'rs-menu-item-bordered': bordered,
    });

    if (loading) {
      return <Grid className={recipeItemClass} padded />;
    }

    return (
      <Grid className={recipeItemClass} padded>
        <Grid.Row>
          <Grid.Column width={4} className="rs-menu-item-image-col">
            <NutritionalHoverConnected
              recipeId={recipeCode}
              showDisclaimer={false}
              showServingCost={true}
              disableHover={disableHover}
            >
              <Image src={imageSrc} className="rs-menu-item-image" />
            </NutritionalHoverConnected>
          </Grid.Column>
          <Grid.Column width={12} className="rs-menu-details">
            <div className="rs-menu-item-title">
              {enableDnD
                ? this.renderDraggableTitle({ index, shortName })
                : this.renderTitle({ shortName })}
              <span className="rs-menu-serving-size" title={ServingSize}>
                {ServingSize}
              </span>
            </div>
            <div className="rs-menu-item-long-name">
              <span title={longName}>{longName}</span>
              <span className="rs-icon-container">
                <Icon
                  className="rs-add-icon"
                  name="plus"
                  onClick={this.onAddRecipe}
                />
                {showIcon && <Icon className={iconClassName} name={iconName} />}
              </span>
            </div>
            <div className="rs-menu-item-attribute-list">
              {footerItems.map((fi, i) => {
                const { fieldName } = fi;

                const value = item[fieldName];
                const itemProps = {
                  className: 'rs-menu-item-attribute',
                  title: value,
                  style: {
                    maxWidth: `${100 / footerItems.length}%`,
                  },
                  key: fieldName,
                  value,
                };

                if (value) {
                  return fi.render(itemProps);
                }

                return null;
              })}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export { RecipeItem };



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/RecipeItem.js